module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"error-unauthorized-access-query":"Vous n\u0027avez pas les droits nécessaires pour accéder à cette information.","error-unauthorized-access-mutation":"Vous n\u0027êtes pas autorisé à effectuer cette action."},"en":{"error-unauthorized-access-query":"You do not have access to this information.","error-unauthorized-access-mutation":"You are not authorized to take this action."}}')
  delete Component.options._Ctor
}
